var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.columns},on:{"cancel":_vm.cancel,"confirm":_vm.onConfirm,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }